import usePermission from "./PermissionProvider";
export { PermissionProvider, PermissionContext } from "./PermissionProvider";
export default usePermission;
